



const ProjetIntegrations = () => {
  return (
    <div>ProjetIntegrations</div>
  )
}

export default ProjetIntegrations